import React, {useEffect, useState} from "react";
import {socket} from "../../../socket";
import AppContext from "../../../app-context";
import {Link} from "react-router-dom";
import {useAuth} from "../../../AuthContext";

import { IconListDetails, IconLayoutGrid, IconBoxMultiple } from "@tabler/icons-react";
import Servers from "../../tables/servers";


const SideBar = ({id, sort, object, path, page, refresh, setRefresh, controller: ControllerComponent}) => {
    const { user } = useAuth();

    const [items, setItems] = useState([]);
    const [orderBy, setOrderBy] = useState("");
    const [isDescending, setIsDescending] = useState(true);

    const [inputValue, setInputValue] = useState('');

    /*const [refresh, setRefresh] = useState(true);*/

    const handleChange = (event) => {
        setInputValue(event.target.value); // Update the input value state
    };

    useEffect(() => {
        socket.on(`${object}:get-items-list-data`, (data) => {
            setItems(data.data || [])
        });

        //refresh &&
        getItems("name")

        return () => {
            socket.off(`${object}:get-items-list-data`)
        };
    },[id, page, refresh]);

    const getItems = (column) => {
        var data = {
            token: user.token,
            //page: AppContext.pages[object].pageNum,
            //items_count: AppContext.rows_per_page,
            simple_search_text: inputValue,
            order_by: column,
            order_rule: isDescending? "desc" : "asc",
        };

        socket.emit(`${object}:get-items-list`, data);
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            getItems(orderBy)
        }
    };

    const handleBlur = () => {
        getItems(orderBy)
    };

    const [hoveredIndex, setHoveredIndex] = useState(null);

    const handleMouseMove = (index) => {
        setHoveredIndex(index);
    };

    const handleClick = (column) => {
        if (column != orderBy){
            setIsDescending(true);
            setOrderBy(column)
        }else{
            setIsDescending((prevState) => !prevState);
        }

        getItems(column)
    };


    //console.log(" ::: controller --- ", controller)

    return <>
        <li>
            <div className="p-3">

                {ControllerComponent &&
                    <>
                        <ControllerComponent singleArgs={{create: 1, refresh, setRefresh}} />
                    </>
                }

                <div className="position-relative">
                    <input type="search" className="form-control search-invoice ps-5" id="text-srh" placeholder="Search"
                           value={inputValue}
                           onChange={handleChange} // Update state on input change
                           onKeyDown={handleKeyDown} // Detect Enter key
                           onBlur={handleBlur} // Handle blur event
                    />
                    <i className="ti ti-search position-absolute top-50 start-0 translate-middle-y fs-6 text-dark ms-3"></i>
                </div>
                <div style={{ marginTop: "1rem", color: "#4e5d7a" }}>
                    <p style={{ margin: "0.5rem 0"}}>
                        <span style={{ margin: "0px 10px 0px 0px", cursor: "pointer", fontWeight: "bold"}}>Sort By:</span>
                        <br />
                        {sort.map((link, index) => (
                            <a href="javascript:void(0)" onClick={() => handleClick(link.column)} style={{ textDecoration: 'none', margin: "0px 10px 0px 0px", cursor: "pointer" }}>
                                {link.label} {orderBy == link.column ? (isDescending  ? '▼' : '▲') : ''}
                            </a>
                        ))}
                    </p>
                </div>
            </div>
        </li>
        {items.map((service, index) => {
            const backgroundColor =
                service.id == id
                    ? "#b3e5fc" // Clicked color
                    : index === hoveredIndex
                    ? "#e1f5fe" // Hovered color
                    : "#fff"; // Default color
            const statusColor =
                service.status === 1 ? "green" :
                    service.status === 2 ? "orange" :
                        "red";

            const isCertificates = object === "certificates";
            const isDomains = object === "domains";
            const isWebsites = object === "websites";
            const isExpiryItem = isCertificates || isDomains;
            const expirationDateRaw = isCertificates ? service.date_to : service.date_expiration;
            const expiration = isExpiryItem && expirationDateRaw ? new Date(expirationDateRaw) : null;
            const expirationLabel = isExpiryItem ? "Expiration date:" : null;
            const expirationValue = (() => {
                if (!isExpiryItem) return null;
                if (!expiration || Number.isNaN(expiration.getTime())) return "—";
                const formatted = expiration.toLocaleString();
                const isExpired = expiration.getTime() < Date.now();
                return isExpired ? `${formatted} (expired)` : formatted;
            })();
            const daysLeft = (() => {
                if (!isExpiryItem || !expiration || Number.isNaN(expiration.getTime())) return null;
                return Math.ceil((expiration.getTime() - Date.now()) / (1000 * 60 * 60 * 24));
            })();
            const badgeClass = (() => {
                if (daysLeft === null) return "bg-secondary";
                if (daysLeft < 0) return "bg-danger";
                if (daysLeft < 4) return "bg-danger";
                if (daysLeft < 11) return "bg-warning text-dark";
                return "bg-success";
            })();

            return (
                <li>
                    <Link to={`/${path}/${service.id}/dashboard`} className={"p-3 bg-hover-light-black border-bottom d-flex align-items-start invoice-user listing-user bg-light-subtle"}>
                        <IconListDetails size={50} color={`var(--bs-${statusColor})`} />
                        <div className="ms-3 d-inline-block w-75">
                            <h6 className="mb-0 invoice-customer d-flex align-items-center justify-content-between">
                                <span className="text-truncate">{service.name}</span>
                                {isExpiryItem && daysLeft !== null && (
                                    <span className={`badge ${badgeClass} ms-2`}>
                                        {daysLeft < 0 ? "expired" : `${daysLeft}d`}
                                    </span>
                                )}
                            </h6>
                            {path === "server" && (
                                <>
                                    <div className="d-flex align-items-center justify-content-between gap-2">
                                        <span className="fs-2 invoice-id text-truncate text-muted">Last Update:</span>
                                        <span className="fs-2 invoice-date text-nowrap text-muted">
                                            {service.last_update || "—"}
                                        </span>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between gap-2">
                                        <span className="fs-2 invoice-id text-truncate text-muted">Uptime:</span>
                                        <span className="fs-2 invoice-date text-nowrap text-muted">
                                            {service.today_uptime ? `${service.today_uptime}%` : "—"}
                                        </span>
                                    </div>
                                </>
                            )}
                            {isWebsites && (
                                <div className="d-flex align-items-center justify-content-between gap-2">
                                    <span className="fs-2 invoice-id text-truncate text-muted">Last Update:</span>
                                    <span className="fs-2 invoice-date text-nowrap text-muted">
                                        {service.last_update || "—"}
                                    </span>
                                </div>
                            )}
                            {isWebsites && (
                                <div className="d-flex align-items-center justify-content-between gap-2">
                                    <span className="fs-2 invoice-id text-truncate text-muted">Uptime:</span>
                                    <span className="fs-2 invoice-date text-nowrap text-muted">
                                        {service.today_uptime ? `${service.today_uptime}%` : "—"}
                                    </span>
                                </div>
                            )}
                            {expirationLabel && (
                                <div className="d-flex align-items-center justify-content-between gap-2">
                                    <span className="fs-3 invoice-id text-truncate text-body-color">{expirationLabel}</span>
                                    {expirationValue && (
                                        <span className={`fs-3 invoice-date text-nowrap text-body-color ${expirationValue.includes("expired") ? "text-danger" : ""}`}>
                                            {expirationValue}
                                        </span>
                                    )}
                                </div>
                            )}
                        </div>
                        {/*
                        <div key={index} style={{
                            display: "flex",
                            alignItems: "center",
                            padding: "0.5rem",
                            margin: "0.5rem 0",
                            backgroundColor,
                            borderRadius: "4px",
                            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                            cursor: "pointer",
                        }} onMouseMove={() => handleMouseMove(index)} onMouseLeave={() => setHoveredIndex(null)}>
                            <div
                                style={{
                                    width: "10px",
                                    height: "10px",
                                    borderRadius: "50%",
                                    backgroundColor: statusColor,
                                    marginRight: "0.5rem",
                                }}
                            ></div>
                            <p style={{margin: 0, fontSize: "14px", color: "#4e5d7a"}}>
                                {service.name}
                            </p>
                        </div>
                        */}
                    </Link>
                </li>
            )
        })}
        <li></li>
    </>

    return <div
        style={{
            width: "25%",
            minWidth: "325px",
            backgroundColor: "#ebf3fe",
            padding: "1rem",
            borderRight: "1px solid #d3d3d3",
        }}
    >
        <button
            style={{
                marginTop: "1rem",
                padding: "0.5rem",
                backgroundColor: "#4e5d7a",
                color: "#fff",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
            }}
        >
            Add Service
        </button>

        <div style={{
            marginTop: "2rem",
            maxHeight: "600px", // Set the maximum height for the scrollable area
            overflowY: "auto", // Enable vertical scrolling
            paddingRight: "0.5rem", // Add padding for scroll bar visibility
        }}
        >
            {items.map((service, index) => {
                const backgroundColor =
                    service.id == id
                        ? "#b3e5fc" // Clicked color
                        : index === hoveredIndex
                        ? "#e1f5fe" // Hovered color
                        : "#fff"; // Default color
                const statusColor =
                    service.status === 1 ? "green" :
                        service.status === 2 ? "orange" :
                            "red";

                return (
                    <Link to={`/${path}/${service.id}/dashboard`}>
                        <div key={index} style={{
                            display: "flex",
                            alignItems: "center",
                            padding: "0.5rem",
                            margin: "0.5rem 0",
                            backgroundColor,
                            borderRadius: "4px",
                            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                            cursor: "pointer",
                        }} onMouseMove={() => handleMouseMove(index)} onMouseLeave={() => setHoveredIndex(null)}>
                            <div
                                style={{
                                    width: "10px",
                                    height: "10px",
                                    borderRadius: "50%",
                                    backgroundColor: statusColor,
                                    marginRight: "0.5rem",
                                }}
                            ></div>
                            <p style={{margin: 0, fontSize: "14px", color: "#4e5d7a"}}>
                                {service.name}
                            </p>
                        </div>
                    </Link>
                )
            })}
        </div>
    </div>
}

export default SideBar;
